import { StageManager } from "@awayjs/stage";
import { Point } from "../geom/Point";
import { SceneImage2D } from "@awayjs/scene";
var BitmapData = (function () {
    function BitmapData(width, height, transparent, fillColor) {
        if (transparent === void 0) { transparent = true; }
        if (fillColor === void 0) { fillColor = 0xffffffff; }
        this._owners = new Array();
        this._adaptee = new SceneImage2D(width, height, transparent, fillColor, false, StageManager.getInstance().getStageAt(0));
        this._adaptee.adapter = this;
    }
    // for AVM1:
    BitmapData.prototype.compare = function (other) {
        return true;
    };
    Object.defineProperty(BitmapData.prototype, "adaptee", {
        get: function () {
            return this._adaptee;
        },
        enumerable: true,
        configurable: true
    });
    BitmapData.loadBitmap = function (id) {
        console.log("loadBitmap not implemented yet in flash/BitmapData");
        return null;
    };
    Object.defineProperty(BitmapData.prototype, "transparent", {
        get: function () {
            return this._adaptee.transparent;
        },
        set: function (value) {
            this._adaptee.transparent = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BitmapData.prototype, "width", {
        get: function () {
            return this._adaptee.width;
        },
        set: function (value) {
            this._adaptee.width = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BitmapData.prototype, "height", {
        get: function () {
            return this._adaptee.height;
        },
        set: function (value) {
            this._adaptee.height = value;
        },
        enumerable: true,
        configurable: true
    });
    BitmapData.prototype.clone = function () {
        var clone = new BitmapData(this._adaptee.width, this._adaptee.height, this._adaptee.transparent, 0x0);
        clone.copyPixels(this, this.rect, new Point());
        return clone;
    };
    Object.defineProperty(BitmapData.prototype, "rect", {
        get: function () {
            return this._adaptee.rect;
        },
        enumerable: true,
        configurable: true
    });
    BitmapData.prototype.getPixel = function (x, y) {
        return this._adaptee.getPixel(x, y);
    };
    BitmapData.prototype.getPixel32 = function (x, y) {
        return this._adaptee.getPixel32(x, y);
    };
    BitmapData.prototype.setPixel = function (x, y, color) {
        this._adaptee.setPixel(x, y, color);
    };
    BitmapData.prototype.setPixel32 = function (x, y, color) {
        this._adaptee.setPixel32(x, y, color);
    };
    BitmapData.prototype.applyFilter = function (sourceBitmap, sourceRect, destPoint, filter) {
        console.log("applyFilter not implemented yet in flash/BitmapData");
        return 0;
    };
    BitmapData.prototype.colorTransform = function (rect, colorTransform) {
        this._adaptee.colorTransform(rect, colorTransform);
    };
    BitmapData.prototype.copyChannel = function (sourceBitmap, sourceRect, destPoint, sourceChannel, destChannel) {
        this._adaptee.copyChannel(sourceBitmap.adaptee, sourceRect, destPoint, sourceChannel, destChannel);
    };
    BitmapData.prototype.copyPixels = function (sourceBitmap, sourceRect, destPoint, alphaBitmapData, alphaPoint, mergeAlpha) {
        if (alphaBitmapData === void 0) { alphaBitmapData = null; }
        if (alphaPoint === void 0) { alphaPoint = null; }
        if (mergeAlpha === void 0) { mergeAlpha = false; }
        this._adaptee.copyPixels(sourceBitmap.adaptee, sourceRect, destPoint);
    };
    BitmapData.prototype.dispose = function () {
        this._adaptee.dispose();
        this._adaptee = null;
    };
    BitmapData.prototype.draw = function (source, matrix, colorTransform, blendMode, clipRect, smooth) {
        if (colorTransform === void 0) { colorTransform = null; }
        if (blendMode === void 0) { blendMode = ""; }
        if (clipRect === void 0) { clipRect = null; }
        if (smooth === void 0) { smooth = false; }
        this._adaptee.draw(source.adaptee, matrix, colorTransform, blendMode, clipRect, smooth);
    };
    BitmapData.prototype.fillRect = function (rect, color) {
        this._adaptee.fillRect(rect, color);
    };
    BitmapData.prototype.floodFill = function (x, y, color) {
        console.log("floodFill not implemented yet in flash/BitmapData");
    };
    BitmapData.prototype.generateFilterRect = function (sourceRect, filter) {
        console.log("generateFilterRect not implemented yet in flash/BitmapData");
        return null;
    };
    BitmapData.prototype.getColorBoundsRect = function (mask, color, findColor) {
        console.log("getColorBoundsRect not implemented yet in flash/BitmapData");
        return null;
    };
    BitmapData.prototype.hitTest = function (firstPoint, firstAlphaThreshold, secondObject, secondBitmapPoint, secondAlphaThreshold) {
        if (secondBitmapPoint === void 0) { secondBitmapPoint = new Point(0, 0); }
        if (secondAlphaThreshold === void 0) { secondAlphaThreshold = 0; }
        console.log("hitTest not implemented yet in flash/BitmapData");
        return false;
    };
    BitmapData.prototype.lock = function () {
        this._adaptee.lock();
    };
    BitmapData.prototype.merge = function (sourceBitmap, sourceRect, destPoint, redMult, greenMult, blueMult, alphaMult) {
        this._adaptee.merge(sourceBitmap.adaptee, sourceBitmap.rect, destPoint, redMult, greenMult, blueMult, alphaMult);
    };
    BitmapData.prototype.noise = function (randomSeed, low, high, channelOptions, grayScale) {
        console.log("noise not implemented yet in flash/BitmapData");
    };
    BitmapData.prototype.paletteMap = function (sourceBitmap, sourceRect, destPoint, redArray, greenArray, blueArray, alphaArray) {
        console.log("paletteMap not implemented yet in flash/BitmapData");
    };
    BitmapData.prototype.perlinNoise = function (baseX, baseY, numOctaves, randomSeed, stitch, fractalNoise, channelOptions, grayScale, offsets) {
        console.log("perlinNoise not implemented yet in flash/BitmapData");
    };
    BitmapData.prototype.pixelDissolve = function (sourceBitmap, sourceRect, destPoint, randomSeed, numberOfPixels, fillColor) {
        console.log("pixelDissolve not implemented yet in flash/BitmapData");
        return 0;
    };
    BitmapData.prototype.scroll = function (x, y) {
        console.log("scroll not implemented yet in flash/BitmapData");
    };
    BitmapData.prototype.threshold = function (sourceBitmap, sourceRect, destPoint, operation, threshold, color, mask, copySource) {
        console.log("threshold not implemented yet in flash/BitmapData");
        return 0;
    };
    BitmapData.prototype.unlock = function () {
        this._adaptee.unlock();
    };
    BitmapData.prototype._addOwner = function (owner) {
        if (this._owners.indexOf(owner) == -1)
            this._owners.push(owner);
    };
    BitmapData.prototype._removeOwner = function (owner) {
        var index = this._owners.indexOf(owner);
        if (index != -1)
            this._owners.splice(index, 1);
        if (!this._owners.length)
            this._adaptee.clear();
    };
    return BitmapData;
}());
export { BitmapData };
